import { supabase } from "@/integrations/supabase/client";

export interface MunicipioCatalogo {
  id: number;
  nombre: string;
  id_estado: number;
}

/** Filas por página: el tope que PostgREST devuelve en una sola respuesta. */
const PAGINA = 1000;

/**
 * Todos los municipios del catálogo (`municipios_mx`), por páginas.
 *
 * Hay unos 2,500 y PostgREST corta cada respuesta en 1,000 filas: pedidos de un
 * jalón y en orden alfabético, la lista se quedaba en «Marqués de Comillas» y
 * faltaban Zamora, Zapopan, Monterrey, Querétaro… Peor: los formularios daban
 * por inválido el municipio guardado que no venía en la lista y lo vaciaban.
 */
export async function fetchMunicipios({ soloActivos = true }: { soloActivos?: boolean } = {}): Promise<
  MunicipioCatalogo[]
> {
  const filas: MunicipioCatalogo[] = [];
  for (let desde = 0; ; desde += PAGINA) {
    let consulta = (supabase as any).from("municipios_mx").select("id, nombre, id_estado");
    if (soloActivos) consulta = consulta.eq("activo", true);
    const { data, error } = await consulta
      .order("nombre")
      .order("id")
      .range(desde, desde + PAGINA - 1);
    if (error) throw error;
    filas.push(...((data ?? []) as MunicipioCatalogo[]));
    if (!data || data.length < PAGINA) break;
  }
  return filas;
}
